export default {
	getHeaders(role) {
		if (role === "author") {
			return {
				field: [
					{ field: "id", 									title: "listTickets.idOrder" },
					{ field: "subject", 							title: "topic" },
					{ field: "pages_number", 						title: "pagesCount" },
					{ field: "milestones_count", 					title: "milestonesCount" },
					{ field: "current_milestones_pages_count", 		title: "currentMilestonesPagesCount" },
					// { field: "name", 						title: "topic" },
					// { field: "chat_messages_count", 		title: "" },
					{ field: "chat_author_messages_count", 			title: "" },
					// { field: "work_type", 					title: "type" },
					// { field: "pages_number", 				title: "pagesCount" },
					// { field: "price_author", 			title: "priceEuro" },
					{ field: "due_date", 							title: "dueDate" },
					// { field: "manager.username", 		title: "manager" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "patch_mode", 				title: "patchMode" },
					{ key: "waiting_approve",  			title: "waitingApprove" },
					{ key: "completed", 				title: "finished" },
				]
			}
		}

		if (role === "manager") {
			return {
				field: [
					{ field: "id", 							title: "listTickets.idOrder" },
					{ field: "created", 					title: "listTickets.timeOrder" },
					{ field: "name", 						title: "listTickets.nameOrder" },
					{ field: "chat_messages_count", 		title: "" },
					{ field: "chat_author_messages_count", 	title: "" },
					{ field: "client.full_name",	 		title: "client" },
					{ field: "client.website",	 			title: "listTickets.websiteOrder" },
					{ field: "pages_number", 				title: "pagesCount" },
					{ field: "due_date", 					title: "dueDate" },
					{ field: "author.username", 			title: "author" },
					{ field: "task", 						title: "task" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "processing", 				title: "processing" },
					{ key: "client_not_answer", 		title: "clientNotAnswer" },
					{ key: "waiting_payment", 			title: "waitingPayment" },
					{ key: "waiting_author", 			title: "waitingAuthor" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "patch_mode", 				title: "patchMode" },
					{ key: "waiting_approve", 			title: "waitingApprove" },
					{ key: "completed", 				title: "completed" },
					{ key: "failed_with_payout", 		title: "failedWithPayout" },
					{ key: "failed", 					title: "failed" },
					{ key: "all", 						title: "all" },
					{ key: "trash", 					title: "trash" },
				]
			}
		}
		
		if (role === "manager2") {
			return {
				field: [
					{ field: "id", 							title: "listTickets.idOrder" },
					{ field: "created", 					title: "listTickets.timeOrder" },
					{ field: "name", 						title: "listTickets.nameOrder" },
					{ field: "chat_messages_count", 		title: "" },
					{ field: "chat_author_messages_count", 	title: "" },
					{ field: "client.full_name",	 		title: "client" },
					{ field: "client.website",	 			title: "listTickets.websiteOrder" },
					{ field: "pages_number", 				title: "pagesCount" },
					{ field: "due_date", 					title: "dueDate" },
					{ field: "author.username", 			title: "author" },
					{ field: "task", 						title: "task" },
				],
				tabs: [
					{ key: "transmitted", 				title: "transmitted" },
					{ key: "client_not_answer", 		title: "clientNotAnswer" },
					{ key: "waiting_payment", 			title: "waitingPayment" },
					{ key: "waiting_author", 			title: "waitingAuthor" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "patch_mode", 				title: "patchMode" },
					{ key: "waiting_approve", 			title: "waitingApprove" },
					{ key: "completed", 				title: "completed" },
					{ key: "failed_with_payout", 		title: "failedWithPayout" },
					{ key: "failed", 					title: "failed" },
					{ key: "all", 						title: "all" },
					{ key: "trash", 					title: "trash" },
				]
			}
		}

		if (role === "admin") {
			return {
				field: [
					{ field: "id", 							title: "listTickets.idOrder" },
					{ field: "created", 					title: "listTickets.timeOrder" },
					{ field: "name", 						title: "listTickets.nameOrder" },
					{ field: "chat_messages_count", 		title: "" },
					{ field: "chat_author_messages_count", 	title: "" },
					{ field: "client.full_name",	 		title: "client" },
					{ field: "client.website",	 			title: "listTickets.websiteOrder" },
					{ field: "pages_number", 				title: "pagesCount" },
					{ field: "due_date", 					title: "dueDate" },
					{ field: "author.username", 			title: "author" },
					{ field: "task", 						title: "task" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "for_removal", 				title: "forRemoval" },
					{ key: "processing", 				title: "processing" },
					{ key: "transmitted", 				title: "transmitted" },
					{ key: "client_not_answer", 		title: "clientNotAnswer" },
					{ key: "waiting_payment", 			title: "waitingPayment" },
					{ key: "waiting_author", 			title: "waitingAuthor" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "patch_mode", 				title: "patchMode" },
					{ key: "waiting_approve", 			title: "waitingApprove" },
					{ key: "completed", 				title: "completed" },
					{ key: "failed_with_payout", 		title: "failedWithPayout" },
					{ key: "failed", 					title: "failed" },
					{ key: "all", 						title: "all" },
					{ key: "trash", 					title: "trash" },
				]
			}
		}

		if (role === "partner") {
			return {
				field: [
					{ field: "id", 							title: "listTickets.idOrder" },
					{ field: "created", 					title: "listTickets.timeOrder" },
					{ field: "name", 						title: "listTickets.nameOrder" },
					{ field: "chat_messages_count", 		title: "" },
					{ field: "chat_author_messages_count", 	title: "" },
					{ field: "client.full_name",	 		title: "client" },
					{ field: "client.website",	 			title: "listTickets.websiteOrder" },
					{ field: "pages_number", 				title: "pagesCount" },
					{ field: "due_date", 					title: "dueDate" },
					{ field: "author.username", 			title: "author" },
					{ field: "task", 						title: "task" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "for_removal", 				title: "forRemoval" },
					{ key: "transmitted", 				title: "transmitted" },
					{ key: "processing", 				title: "processing" },
					{ key: "client_not_answer", 		title: "clientNotAnswer" },
					{ key: "waiting_payment", 			title: "waitingPayment" },
					{ key: "waiting_author", 			title: "waitingAuthor" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "patch_mode", 				title: "patchMode" },
					{ key: "waiting_approve", 			title: "waitingApprove" },
					{ key: "completed", 				title: "completed" },
					{ key: "failed_with_payout", 		title: "failedWithPayout" },
					{ key: "failed", 					title: "failed" },
					{ key: "all", 						title: "all" },
					{ key: "trash", 					title: "trash" },
				]
			}
		}

		if (role === "supervisor") {
			return {
				field: [
					{ field: "id", 							title: "listTickets.idOrder" },
					{ field: "created", 					title: "listTickets.timeOrder" },
					{ field: "name", 						title: "listTickets.nameOrder" },
					{ field: "chat_messages_count", 		title: "" },
					{ field: "chat_author_messages_count", 	title: "" },
					{ field: "client.full_name",	 		title: "client" },
					{ field: "client.website",	 			title: "listTickets.websiteOrder" },
					{ field: "pages_number", 				title: "pagesCount" },
					{ field: "due_date", 					title: "dueDate" },
					{ field: "author.username", 			title: "author" },
					{ field: "task", 						title: "task" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "for_removal", 				title: "forRemoval" },
					{ key: "transmitted", 				title: "transmitted" },
					{ key: "processing", 				title: "processing" },
					{ key: "client_not_answer", 		title: "clientNotAnswer" },
					{ key: "waiting_payment", 			title: "waitingPayment" },
					{ key: "waiting_author", 			title: "waitingAuthor" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "patch_mode", 				title: "patchMode" },
					{ key: "waiting_approve", 			title: "waitingApprove" },
					{ key: "completed", 				title: "completed" },
					{ key: "failed_with_payout", 		title: "failedWithPayout" },
					{ key: "failed", 					title: "failed" },
					{ key: "all", 						title: "all" },
					{ key: "trash", 					title: "trash" },
				]
			}
		}
	}
}
